/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";

import type { KangGangNFT } from "../KangGangNFT";

export class KangGangNFT__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<KangGangNFT> {
    return super.deploy(overrides || {}) as Promise<KangGangNFT>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): KangGangNFT {
    return super.attach(address) as KangGangNFT;
  }
  connect(signer: Signer): KangGangNFT__factory {
    return super.connect(signer) as KangGangNFT__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): KangGangNFT {
    return new Contract(address, _abi, signerOrProvider) as KangGangNFT;
  }
}

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "_tokenURI",
        type: "string",
      },
    ],
    name: "setTokenURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
